import {
  communeSchema,
  dvfResponseSchema,
  type Commune,
  type DvfPropertyType,
  type DvfResponse,
} from '@app/shared';
import { z } from 'zod';
import { apiFetch } from '@/lib/api';

export function searchCommunes(query: string): Promise<Commune[]> {
  return apiFetch(`/api/market/communes?q=${encodeURIComponent(query)}`, { schema: z.array(communeSchema) });
}

export function fetchCommuneDvf(code: string, propertyType: DvfPropertyType, refresh: boolean): Promise<DvfResponse> {
  const params = new URLSearchParams({ propertyType, refresh: String(refresh) });
  return apiFetch(`/api/market/communes/${code}/dvf?${params.toString()}`, { schema: dvfResponseSchema });
}
